export const HoneypotField: React.FC<{
  honeypotField: any;
  value: string;
  onChange: (value: string) => void;
}> = ({ honeypotField, value, onChange }) => {
  return (
    honeypotField?.honeypotEnabled && (
      <input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        type="text"
        className="regular-input"
        tabIndex={-1}
        aria-hidden="true"
        name={honeypotField.honeypotFieldName}
      />
    )
  );
};
